import React from "react";
import { Chip, Typography, Stack } from "@mui/material";
import { TEXT_COLOR_PRIMARY } from "../../../constants/colors";
import { FONT_SIZE } from "../../../constants/fontSizes";
import { useIsDesktop } from "../../shared/hooks/useIsDesktop";

/**
 * プロフィールの補足情報アイテム
 *
 * - エンジニア歴
 * - 国籍
 * - 最寄駅
 * - 最終学歴
 */
const ProfileInfoItem = ({ label, value, isPublicPage = false }) => {
  const isDesktop = useIsDesktop();
  return (
    <Stack
      direction={isDesktop ? "row" : "column"}
      spacing={isDesktop ? 1.5 : 0.5}
      alignItems="flex-start"
    >
      <Chip
        label={label}
        size="small"
        sx={{
          width: isDesktop ? 100 : "100%",
          justifyContent: "center",
          bgcolor: "#B3B6EA",
          color: "#fff",
          fontWeight: "bold",
          flexShrink: 0,

          // label：スマホは左寄せ、PCは真ん中
          "& .MuiChip-label": {
            width: "100%",
            textAlign: isDesktop ? "center" : "left",
          },
        }}
      />
      <Typography
        sx={{
          color: isPublicPage ? "transparent" : TEXT_COLOR_PRIMARY,
          textShadow: isPublicPage ? "0 0 8px rgba(0,0,0,0.9)" : "none",
          userSelect: isPublicPage ? "none" : "text",
          fontSize: FONT_SIZE.SM,
          flex: 1,
          wordBreak: "break-word",
        }}
      >
        {value || "未登録"}
      </Typography>
    </Stack>
  );
};

export default ProfileInfoItem;
